@if (value() === null) {
<mat-icon class="value-icon--na" [matTooltip]="'shared.general.labels.na' | translate">do_not_disturb_on</mat-icon>
} @else {
<mat-icon [class.value-icon--true]="value()" [class.value-icon--false]="!value()">
  {{ value() ? 'check_circle' : 'cancel' }}
</mat-icon>
}